/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";

import { Button } from "@/shadcnComponents/ui/button";
import MobileMenuBar from "@/Components/Menubar/MobileMenuBar";

import mixpanel from "mixpanel-browser";
import { cn } from "@/lib/utils";
import { LiveAnchorsCollabs } from "../Dashboard/DashboardComponents/DashboardOrganism/DashboardOrganism";

export type BrandCollabSection = "New" | "Ongoing" | "Completed";

export const BrandCollabs = () => {
  const [currentSection, setCurrentSection] =
    useState<BrandCollabSection>("New");

  useEffect(() => {
    mixpanel.track("Influencer Brand Collab Page Visited");
  }, []);

  const handleSelectSection = (section: BrandCollabSection) => {
    setCurrentSection(section);
  };

  return (
    <>
      <MobileMenuBar />
      <div className="w-full font-inter mb-20 md:mb-0 px-10 py-5 box-border flex items-center text-[#EEE] justify-between h-max ">
        <section className="flex flex-col gap-[10px] w-full">
          <span className="text-[color:var(--Shade-White,#FFF)] text-base not-italic font-bold leading-5">
            Brand Collaborations
          </span>
          <span className=" text-[#ADADAD] text-xs not-italic font-normal leading-5">
            Find, manage, and track all your collaborations—new, active, and
            completed—in one place
          </span>

          <div className="flex h-8 items-start content-start gap-3 shrink-0 flex-wrap mt-10 ">
            {(["New", "Ongoing", "Completed"] as BrandCollabSection[])?.map(
              (item) => {
                return (
                  <Button
                    onClick={() => handleSelectSection(item)}
                    className={cn(
                      "border text-neutral-400 text-xs not-italic py-1 h-[34px] font-medium leading-6 rounded-[1000px] border-solid border-[rgba(255,255,255,0.60)]",
                      currentSection === item
                        ? "leading-6 text-[#121212] bg-[#A6A6A6]"
                        : ""
                    )}
                    variant="ghost"
                  >
                    {item}
                  </Button>
                );
              }
            )}
          </div>

          <LiveAnchorsCollabs
            showErrorMessage
            currentFilter={currentSection}
            className="mt-5 w-full md:w-3/4 "
          />
        </section>
      </div>
    </>
  );
};
